import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { phonePlaceholderInForm } from 'components/Users/helper';
import getValidationSchema from './formValidations';
import HGError from 'components/HGForm/HGError';
import HGFormSubmitBtn from './HGFormSubmitBtn';
import HGFormInput from './HGFormInput';
import AddressFields from 'components/HGForm/AddressFields';
import { Separator } from 'components/shadcn/ui/separator';
import { addSpaceBeforeEveryCapitalLetter } from './helpers';

const HGForm = ({
    fields,
    handleSubmit,
    horizontal,
    buttonText,
    errorMessage,
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const fieldsKeys = Object.keys(fields);
    
    // Create initial values, including nested address fields
    const initialValues = fieldsKeys.reduce((acc, field) => {
        if (field === 'address') {
            acc.address = {
                address: '',
                city: '',
                state: '',
                zip: '',
            };
        }
        return acc;
    }, {});

    // Create validation schema, including nested address fields
    const schemaShape = fieldsKeys.reduce((acc, field) => {
        const schema = getValidationSchema(field);
        const fieldLabel = addSpaceBeforeEveryCapitalLetter(field);
        acc[field] = schema.required(`${fieldLabel} is required`);
        return acc;
    }, {});

    const validationSchema = Yup.object().shape(schemaShape);

    const submit = async (values) => {
        setIsSubmitting(true);
        await handleSubmit(values);
        setIsSubmitting(false);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submit}
            validateOnBlur={false}
            validateOnChange={false}
        >
            <Form className="w-full">
                <div
                    className={`grid gap-3 ${
                        horizontal ? 'grid-cols-2' : 'grid-cols-1'
                    }`}
                >
                    {Object.entries(fields).map(([key, value]) => {
                        const type = key.toLowerCase().includes('password')
                            ? 'password'
                            : 'text';

                        const placeholder =
                            value.toLowerCase().includes('phone') > 0
                                ? phonePlaceholderInForm
                                : '';

                        return key === 'address' ? (
                            <AddressFields />
                        ) : (
                            <HGFormInput
                                key={key}
                                name={key}
                                label={value}
                                placeholder={placeholder}
                                type={type}
                            />
                        );
                    })}
                </div>
                {errorMessage && <HGError errorMessage={errorMessage} />}
                <Separator className="my-8" />
                <HGFormSubmitBtn loading={isSubmitting} className="w-full">
                    {buttonText}
                </HGFormSubmitBtn>
            </Form>
        </Formik>
    );
};

export default HGForm;
